import LabeledIcon from './LabeledIcon';

export default LabeledIcon;
